// extracted by mini-css-extract-plugin
module.exports = {"noElements":"styles_noElements__1Z1Vr","noElementsContent":"styles_noElementsContent__1lerm","augurPic":"styles_augurPic__3-arI","addButton":"styles_addButton__1h61m"};